import React from 'react';
import { connect } from 'react-redux';

import { Card, CardBlock, CardTitle , Button , Dropdown , DropdownToggle, 
  DropdownMenu, DropdownItem,Input
} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';
import IconForms from 'react-icons/lib/fa/wpforms'

import * as actions from '../../actions/cliente';
import Modal from "./Modal";
import _ from "lodash";
import {api, API_URL} from '../../actions/_request';

import swal from 'sweetalert2';
import moment from 'moment';

import KardexProveedor from './ModalKardexCliente';
import ModalRecalculo from './ModalRecalculo';
import ModalEstadoCuenta from './ModalEstadoCuenta/Modal';

const requestData = (pageSize, page, sorted, filtered,filtro) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        var label="";
        var contacto="";
        var telefono="";
        var rfc="";
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "label":
              label=filtered[i].value;
              break;
            case "contacto":
              contacto=filtered[i].value;
              break;
            case "telefono":
              telefono=filtered[i].value;
              break;
            case "rfc":
              rfc=filtered[i].value;
              break;            
          }
        }
        api().get(`/clientes/conteo?filtro=${filtro}&label=${label}&contacto=${contacto}&telefono=${telefono}&rfc=${rfc}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/clientes/busqueda?filtro=${filtro}&label=${label}&contacto=${contacto}&telefono=${telefono}&rfc=${rfc}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
            }
        });
    });
};
class Departamentos extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
             data: [],
             pages: null,
             loading: true,
             seleccion_id : '',

             
            kardexModal : false,
            opcionConsulta : 0,
            filtro:0,
            recargar:true,
            modal_recalculo:false,
            modal_estado_cuenta:false,
             altas:false,
            bajas:false,
            cambios:false,
            reportes:false,


        };
        this.toggle 			= this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleChangecheckbox       = this.handleChangecheckbox.bind(this);
        this.toggleKardex = this.toggleKardex.bind(this);
        this.toggle_drop       = this.toggle_drop.bind(this);
         this.recargar2 = this.recargar2.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.recalculo_clientes = this.recalculo_clientes.bind(this);
        this.estado_cuentas_clientes = this.estado_cuentas_clientes.bind(this);
    }

    estado_cuentas_clientes(){
      let {modal_estado_cuenta} = this.state;

        this.setState({
            modal_estado_cuenta       : !modal_estado_cuenta,
        });

    }

    recalculo_clientes(){
      let {modal_recalculo} = this.state;

        this.setState({
            modal_recalculo       : !modal_recalculo,
            recargar:!modal_recalculo,
        });

    }

    handleSelectChange(select, name,tipo=0) {;
      let value=null;
        if(tipo==0){
           value = select === null ? null : select.target.value;
        }else{
           value = select === null ? null : select.value;
        }
     
        this.setState({[name] : value,
                        recargar:false,
                        data:[],
                      });

    }
     recargar2(){
        this.setState({
          recargar:true,
      });
    }
    get_cliente(cliente = null){
    
    
          
  
  }
 fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.filtro,
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
    });
  }
   toggle(evt, prospectoid = null, title = "Agregar Cliente")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }

    componentDidMount() {
       // this.props.get();
      
          if (typeof this.props.auth.permisos === "undefined") {
            
          } else {
           console.log('permisos--->',this.props.auth.permisos[1])
           let permisos=this.props.auth.permisos[1];
           this.setState({
              altas:parseInt(permisos.altas)===1?true:false,
              bajas:parseInt(permisos.bajas)===1?true:false,
              cambios:parseInt(permisos.cambios)===1?true:false,
              reportes:parseInt(permisos.reportes)===1?true:false,
              });
           
          }
    }

     handleChangecheckbox(row)
  {
         
    let bandera=0;
    this.setState({
      seleccion_id : parseInt( row.original.value),
      seleccion_label : row.original.label,
    });  
  }

  toggle_drop(menu,id) {
    let valor=0;

    if(menu===1){
      if(parseInt(this.state.menu)!==id)
        valor=id;
        this.setState({
          menu: valor
        });
    }else{
      if(parseInt(this.state.submenu)!==id)
        valor=id;
        this.setState({
          submenu: valor
        });
    }
  }

  facturas_vencidas(){

    // window.open(`${API_URL}/clientes/cuentas_vencidas`);
    swal.queue([{
        title: 'Dias de Vencimiento',
        text: "Mas de ",
        input: 'select',
        inputOptions :
        {
          0 : 'Todas',
          7 : '7 Dias',
          14 : '14 Dias',
          21 : '21 Dias',
          
        },
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: (opcion) => {
          return window.open(`${API_URL}/clientes/cuentas_vencidas/${opcion}`)
            
            
        }
      }]);
  }

  toggleKardex(evt, opcion, title = "Cargos / Abonos")
    {
      let {seleccion_id} = this.state;
      let modal=true;
      let self=this;
      if (typeof opcion === 'undefined') {
      // se ejecutan estas instrucciones
      let {kardexModal} = this.state;
      this.setState({
                        kardexModal       : !kardexModal,
                        title       : '',
                        opcionConsulta : null
                    });
      return;

      }
       if(opcion==0) {
            window.open(`${API_URL}/clientes/cuentas_cobrar`);
        }else{
           // if(opcion==5) {
            // this.facturas_vencidas();
            // }else{
              if(opcion==6||opcion==5){
                    let {kardexModal} = this.state;
                    let {opcionConsulta} = this.state;

                    opcionConsulta = opcion;

                    this.setState({
                        kardexModal       : !kardexModal,
                        title       : title,
                        opcionConsulta : opcionConsulta
                    });

              }else{
                if(seleccion_id !== ''){
                  if(opcion==4){
                      modal=false;
                      this.setState({
                          recargar:false,
                      });
                      this.props.recalcular_saldo(seleccion_id, (data) => {
                              self.props.alerta({
                                mensaje:"Se Recalculo el saldo Exitosamente",
                                tipo:"success",
                                creacion:moment().format('Y-MM-DD H:m:s'),
                              });
                          });

                  }
                    
                  if(modal){
                    let {kardexModal} = this.state;
                    let {opcionConsulta} = this.state;

                    opcionConsulta = opcion;

                    this.setState({
                        kardexModal       : !kardexModal,
                        title       : title,
                        opcionConsulta : opcionConsulta
                    });
                  }

                 
                }else{
                  console.log('opcion--->',opcion)
                  if (typeof opcion !== 'undefined') {
                        swal("Oops..", "Por favor Seleccione un Cliente");
                      }
                      }
                    }//fin el else opcion 6
        // }


          
      }
    }

    render() {
   const { data, pages, loading,recargar } = this.state;
   const { altas,bajas,cambios,reportes } = this.state;

   if(recargar==false)
            setTimeout(this.recargar2() , 3);

        return(
            <div className="view">

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Clientes</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        { reportes&&
                        <div className="col text-left">
                            <Dropdown nav className='btn-sm info' color="" isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle_drop(1,1);}} >
                              <DropdownToggle nav caret>
                               <IconForms/>Consultas
                              </DropdownToggle>
                              <DropdownMenu className='letras_menu'>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,0,'Cuentas por Cobrar')}>Cuentas por Cobrar</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,5,'Cuentas Vencidas')}>Cuentas Vencidas</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,1,'Cargos / Abonos')}>Cargos / Abonos</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,2, 'Facturas / Abonos')}>Facturas / Abonos</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,3, 'Productos comprados')}>Productos Comprados</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,4,'Recalcular Saldo Individual')}>Recalcular Saldo Individual</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,6,'Seguimiento Clientes')}>Seguimiento Clientes</DropdownItem>
                                <DropdownItem onClick={(e) => this.recalculo_clientes(e,7,'Recalcular Saldo Masivo')}>Recalcular Saldo Masivo</DropdownItem>
                                 <DropdownItem onClick={(e) => this.estado_cuentas_clientes(e,8,'Envio de Estado de Cuentas Vencidas ')}>Envio de Estado de Cuentas Vencidas  </DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        }

                          <div className="text-right">
                          <div className="row">
                          <div className="col-md-6"> </div>
                        <div className="col-md-3"> 
                                    <div className="form-group">
                                      <Input type="select" 
                                        name="filtro" 
                                        id="filtro" 
                                        value={this.state.filtro} 
                                        onChange={(e) => this.handleSelectChange(e,'filtro')} >
                                        <option value={0}>Todos</option>
                                        <option value={1}>Con Saldo</option>
                                      </Input>
                                  </div>
                        </div>
                        { altas&&
                        <div className="col-md-3"> 
                          <div className="form-group">
                             <Button color="success" className="mb-2" onClick={this.toggle}>
                                    <IconPersonAdd />&nbsp;Agregar
                                </Button>
                          </div>
                        </div>
                      }
                    </div>
                          </div>
                        <div className="text-right">
                               
                            </div>
                            {(recargar==true)&&<ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>{
                                              if(cambios){
                                                 this.toggle(evt, rowInfo.original.value, 'Editar Cliente')
                                              }else{
                                                 swal('', 'No tienes permisos para editar');
                                              }
                                            }
                                        } 
                                  
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                               {
                                    Header: 'Seleccion',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    minWidth:80, 
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">
                                                <input type="checkbox"
                                                name="" 
                                                checked={(this.state.seleccion_id === parseInt( row.original.value)) ? true : false}
                                                onChange={() => this.handleChangecheckbox(row)}/>                                                 
                                            </div>
                                        )
                                    }
                                },
                                {Header: 'Cliente', accessor: 'label' ,minWidth:500, style: { 'textAlign': 'left'}},
                                {Header: 'Saldo', accessor: 'saldo' ,maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Contacto', accessor: 'contacto',minWidth:500, style: { 'textAlign': 'left'} },
                                {Header: 'RFC', accessor: 'rfc',maxWidth:150,minWidth:150 , style: { 'textAlign': 'left'}},
                                {Header: 'Telefono', accessor: 'telefono' ,maxWidth:150,minWidth:150 , style: { 'textAlign': 'left'}},
                               

                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                             {cambios&&
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.value, 'Editar Cliente')}>
                                                    <IconEdit />
                                                </Button>}{' '}
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10}
                             
                              
                             
                            />
                          }
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <Modal 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                 get_cliente={this.get_cliente}
                />
                }
                {
                   this.state.kardexModal&& 
                   <KardexProveedor 
                 open={this.state.kardexModal} 
                 toggle={this.toggleKardex} 
                 title={this.state.title} 
                 proveedor={this.state.seleccion_id}
                 nombreProveedor={this.state.seleccion_label}
                 consulta={this.state.opcionConsulta}
                />
                }
                {
                   this.state.modal_recalculo&& 
                   <ModalRecalculo 
                 open={this.state.modal_recalculo} 
                 toggle={this.recalculo_clientes} 
                 title={'Recalculo de Saldos'} 

                />
                }
                {
                   this.state.modal_estado_cuenta&& 
                   <ModalEstadoCuenta 
                 open={this.state.modal_estado_cuenta} 
                 toggle={this.estado_cuentas_clientes} 
                 title={'Envio Masivo de Estados de Cuenta'} 

                />
                }
                 

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        cliente : state.cliente,
        notificciones:state.notificciones,
        auth:state.auth,
    }
};

export default connect(mapStateToProps, actions)(Departamentos)


// WEBPACK FOOTER //
// ./src/views/clientes/index.js